<template>
  <div>
    <DonationProductsList ref="listProductsDialog" :campaignLandingPage="campaignLandingPageConfig"></DonationProductsList>
    <UseTermsModal v-model="showServiceTerms"></UseTermsModal>
    <PrivacyPolicyTermsModal v-model="showPolicyTerms"></PrivacyPolicyTermsModal>

    <PaginaProjeto
      v-if="projectLP && projectLP.project"
      :projeto="projeto"
      :heroStyle="heroStyle"
      :themeVars="themeVars"
      @doar="goToCartWithThisProject"
    >
      <template #simulador>
        <!-- Container do simulador inline (widget AUC auto-hospedado em /vendor) -->
        <div id="auc-simulador-inline" class="sim-inline-wrap"></div>
      </template>
    </PaginaProjeto>

    <!-- Footer do sistema (mesmo da LP de campanha): cor da campanha + termos de uso -->
    <template v-if="projectLP && projectLP.project">
      <footer class="display-flex flex-column">
        <div class="pa-5 direitos display-flex justify-center bg-theme-primaria">
          <h6 class="fw-400">
            {{ projeto.instituicao.razaoSocial }} © {{ getActualYear() }} - Todos os direitos reservados
          </h6>
        </div>
      </footer>
      <!-- wrapper próprio (sem .container/.v-layout do Vuetify, cuja cadeia flex inflava
           o .termo via flex:1 gerando um bloco vazio gigante) -->
      <div class="pp-footer-termo">
        <div class="termo text-italic">
          <div>
            Powered by
            <span class="td-u ml-1 p-0">abraceumacausa.com.br</span>
          </div>
          <div>
            <a class="with-border" @click="showServiceTerms = !showServiceTerms; $gtag('send', 'event', 'Saiba Mais', 'Termos de Uso', 'Footer')">Termo de uso</a>
            <a @click="showPolicyTerms = !showPolicyTerms; $gtag('send', 'event', 'Saiba Mais', 'Política de Privacidade', 'Footer')">Política de privacidade</a>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script type="plain/text">
import UseTermsModal from "@/components/UseTermsModal.vue";
import PrivacyPolicyTermsModal from "@/components/PrivacyPolicyTermsModal.vue";
import DonationProductsList from "@/components/DonationProductsList.vue";
import PaginaProjeto from "@/views/web/project/PaginaProjeto.vue";
import { FileType } from "@/scripts/models/enums/fileType.enum";
import FileProject from "@/scripts/models/fileProject.model";
import ProjectLandingPageConfig from "@/scripts/models/projectLandingPageConfig.model";
import ProjectService from "@/scripts/services/project.service";
import CampaignService from "@/scripts/services/campaign.service";
import FileService from "@/scripts/services/file.service";
import FileProjectService from "@/scripts/services/fileProject.service";
import { Routes } from "@/scripts/models/enums/routes.enum.js";
import { getCheckoutRoute } from "@/scripts/helpers/checkoutRoute.helper";
import { CampaignPhases } from "@/scripts/models/enums/campaignPhases.enum";
import {
  ProjectTypes,
  GetProjectTypeName
} from "@/scripts/models/enums/projectTypes.enum.js";
import FormatterHelper from "@/scripts/helpers/formatter.helper";
import CommonHelper from "@/scripts/helpers/common.helper";
import { mapToProjetoContrato } from "@/scripts/helpers/projetoContrato.helper";
import { INCENTIVE_LAW_SHORT_LABEL } from "@/scripts/helpers/incentiveLawLabel.helper";
import moment from "moment";
import CampaignAppreciationCampaignProduct from "@/scripts/services/campaignAppreciationCampaignProduct.service";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    UseTermsModal,
    PrivacyPolicyTermsModal,
    DonationProductsList,
    PaginaProjeto
  },
  props: ["projectId", "landingPageOptions"],
  data() {
    return {
      campaignService: new CampaignService(),
      edit: false,
      fileType: FileType,
      fileProjectList: [],
      showPolicyTerms: false,
      showServiceTerms: false,
      campaign: null,
      campaignLandingPage: null,
      projectLP: new ProjectLandingPageConfig(),
      campaignAppreciationCampaignProduct: new CampaignAppreciationCampaignProduct(),
      projectService: new ProjectService(),
      fileProject: new FileProject(),
      fileProjectService: new FileProjectService(),
      fileService: new FileService(),
      formatterHelper: new FormatterHelper(),
      color_primary: "#16AEB5",
      color_secondary: "#D2E793",
      targetAudienceList: [],
      getProjectTypeName: GetProjectTypeName,
      ProjectTypes: ProjectTypes,
      routes: Routes,
      donationProductList: [],
      appreciations: []
    };
  },
  beforeRouteEnter: (to, from, next) => {
    // identificador na rota (/projeto/:idOrSlug) com fallback para a query legada (?projectId=)
    const idOrSlug = to.params.idOrSlug || to.query.projectId;
    if (idOrSlug && idOrSlug != 0) {
      let projectService = new ProjectService();
      projectService
        .buildProjectLandingPageByIdOrSlug(idOrSlug)
        .then(function (data) {
          to.query.projectLP = data;
          if (CommonHelper.getSubdomain()) {
            new CampaignService()
              .getCampaignLandingPageConfigBySubdomain()
              .then(data => {
                to.query.campaignLandingPage = data;
                to.query.campaign = data.campaign;
                to.query.navFile = data.campaign.file;
                next();
              });
          } else {
            next();
          }
        });
    } else {
      next({ name: Routes.app.DashboardPF });
    }
  },
  watch: {
    async appreciationList() {
      await this.addCampaignProduct();
      await this.addDonationProduct();
    }
  },
  computed: {
    ...mapGetters(["campaignLandingPageConfig", "appreciationList", "logged"]),
    showDonationButton() {
      if (this.projectLP && this.projectLP.project && this.campaign) {
        return (
          CommonHelper.getSubdomain() != null &&
          this.projectLP.project.captureStatus &&
          this.campaign.campaignPhaseId == CampaignPhases.EmAndamento &&
          this.campaign.published
        );
      }
      return false;
    },
    shareLink() {
      return window.location.href;
    },
    targetAudienceName() {
      if (!this.projectLP || !this.projectLP.project) return "";
      const ta = (this.targetAudienceList || []).find(
        x => x.id === this.projectLP.project.targetAudienceId
      );
      return ta ? ta.name : "";
    },
    projeto() {
      return mapToProjetoContrato(this.projectLP, {
        fileProjectList: this.fileProjectList,
        captacaoAberta: this.showDonationButton,
        targetAudienceName: this.targetAudienceName
      });
    },
    // Cores da campanha em [r,g,b] (primária/secundária). null quando a campanha
    // não tem tema definido -> o PaginaProjeto mantém os tokens padrão da marca AUC.
    campaignColors() {
      const c = this.campaignLandingPage;
      if (!c) return null;
      const primary = this.themeRgbArray(c.themePrimaria || c.ThemePrimaria);
      const secondary = this.themeRgbArray(c.themeSecundaria || c.ThemeSecundaria);
      if (!primary) return null;
      return { primary: primary, secondary: secondary || primary };
    },
    // Gradiente do hero com as cores da campanha (themePrimaria -> themeSecundaria).
    heroStyle() {
      const cc = this.campaignColors;
      if (!cc) return null;
      return {
        background:
          "linear-gradient(135deg, " +
          this.rgbStr(cc.primary) +
          " 0%, " +
          this.rgbStr(cc.secondary) +
          " 100%)"
      };
    },
    // Paleta completa aplicada no root do PaginaProjeto (todas as seções). Deriva os
    // tons escuros (escurecendo a primária) e os tons claros mist/sand (clareando a
    // primária), mapeando para os CSS custom properties usados pelo componente.
    // null => o componente mantém os tokens padrão da marca AUC definidos no CSS.
    themeVars() {
      const cc = this.campaignColors;
      if (!cc) return null;
      const p = cc.primary;
      const s = cc.secondary;
      return {
        "--teal": this.rgbStr(p),
        "--teal-700": this.rgbStr(this.darken(p, 0.16)),
        "--teal-900": this.rgbStr(this.darken(p, 0.42)),
        "--teal-ink": this.rgbStr(this.darken(p, 0.58)),
        "--lime": this.rgbStr(s),
        "--lime-700": this.rgbStr(this.darken(s, 0.18)),
        // secundária clareada para uso como ACENTO sobre faixas escuras (métricas):
        // se a secundária é escura, clareia para garantir contraste; se já é clara, mantém.
        "--lime-bright": this.luminance(s) < 140 ? this.rgbStr(this.tint(s, 0.5)) : this.rgbStr(s),
        // ACENTO dos números das métricas (faixa escura): usa a secundária só quando ela é
        // clara o bastante para contrastar; caso contrário (preto, cores escuras/médias),
        // usa branco — evita número cinza/apagado quando a secundária não serve de acento.
        "--metric-accent": this.luminance(s) > 150 ? this.rgbStr(s) : "#fff",
        // cor de acento "cheia" (barra de progresso, dot de status, blobs decorativos):
        // usa a secundária quando utilizável; se muito escura (preto) ou muito clara (branco),
        // cai para a primária — evita preto/branco chapado nesses elementos.
        "--accent-fill": (this.luminance(s) >= 40 && this.luminance(s) <= 220) ? this.rgbStr(s) : this.rgbStr(p),
        // texto sobre a cor secundária (botões/step lime): claro em secundária escura,
        // escuro em secundária clara — evita CTA ilegível quando a campanha usa cor escura
        "--lime-ink": this.luminance(s) > 150 ? "#13323a" : "#fff",
        // tinta de contraste do HERO (fundo = gradiente da primária): texto do hero usa
        // isto. Claro sobre primária escura, escuro sobre primária clara.
        "--hero-ink": this.luminance(p) > 150 ? "#13323a" : "#fff",
        // CTA do hero = bloco na cor --hero-ink (contrasta com o gradiente) + label na
        // cor oposta (sempre legível sobre o bloco). Destaca o botão em qualquer campanha.
        "--hero-cta-fg": this.luminance(p) > 150 ? "#fff" : "#13323a",
        "--mist": this.rgbStr(this.tint(p, 0.88)),
        "--mist-2": this.rgbStr(this.tint(p, 0.8)),
        "--sand": this.rgbStr(this.tint(p, 0.955))
      };
    }
  },
  async created() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0;
    window.scrollTo(0, 0);
    this.projectLP = this.$route.query.projectLP;
    this.edit = this.$route.query.edit;
    this.fileProjectService.listByProjectIdAndType(
      this.listFileProjectCallback,
      this.projectLP && this.projectLP.project ? this.projectLP.project.id : this.$route.query.projectId,
      this.fileType.ImagemGaleriaProjeto
    );
    this.projectService.listAllTargetAudience(
      this.listAllTargetAudienceCallback
    );
    if (this.$route.query.navFile) {
      this.$set(this.landingPageOptions, "logo", this.$route.query.navFile);
    }
    if (this.$route.query.campaign) {
      this.campaign = this.$route.query.campaign;
    }
    if (this.$route.query.campaignLandingPage) {
      this.campaignLandingPage = this.$route.query.campaignLandingPage;
    }
  },
  mounted() {
    this.applyGlobalTheme();
    this.getAppreciationList();
    this.$nextTick(() => this.mountSimulador());
  },
  beforeDestroy() {
    // limpa o widget do simulador para reinicializar limpo ao reentrar/trocar de projeto
    var s = document.getElementById("auc-simulador-script");
    if (s && s.parentNode) s.parentNode.removeChild(s);
    var host = document.getElementById("auc-sim-host");
    if (host && host.parentNode) host.parentNode.removeChild(host);
    window.__aucSimLoaded = undefined;
    window.AUCSimulador = undefined;
  },
  methods: {
    ...mapActions(["setLandingPageConfig", "getAppreciationList", "addToCart"]),
    // Garante as CSS vars globais de tema (--theme-primaria/-secundaria) usadas pelo
    // footer do sistema (.bg-theme-primaria em public/projeto.css). Necessário no acesso
    // direto à URL do projeto, quando a LP de campanha (Inner.vue) não chegou a rodar.
    applyGlobalTheme() {
      const cc = this.campaignColors;
      if (!cc) return;
      const root = document.documentElement.style;
      root.setProperty("--theme-primaria", cc.primary.join(", ") + ", 1");
      root.setProperty("--theme-secundaria", cc.secondary.join(", ") + ", 1");
    },
    mountSimulador() {
      if (!this.projectLP || !this.projectLP.project) return;
      // Simulador de IR só faz sentido em ProjetoIncentivado (typeId=1).
      // Voluntariado/Ticket/SemIncentivo não têm dedução — a seção fica oculta no template.
      if (this.projectLP.project.projectTypeId !== ProjectTypes.ProjetoIncentivado) return;
      if (document.getElementById("auc-simulador-script")) return;
      var p = this.projectLP.project;
      var s = document.createElement("script");
      s.id = "auc-simulador-script";
      s.src = "/vendor/auc-simulador-widget.js";
      s.setAttribute("data-mode", "inline");
      s.setAttribute("data-target", "#auc-simulador-inline");
      var slug = CommonHelper.getSubdomain();
      if (slug) s.setAttribute("data-campaign", slug);
      // fixa o percentual correto (Esporte=7 / demais=6); simulatorPercentage vem null em homolog
      s.setAttribute(
        "data-campaign-type",
        p.incentiveLawId === 3 ? "esporte" : "cultura"
      );
      // Nome da causa no botão "Tipo de incentivo" (AUC-125). Aqui é a lei DESTE projeto,
      // não a da campanha: a página é de um projeto só, e dizer "Cultura, Esporte e Social"
      // numa página de projeto de conselho seria pior que o rótulo genérico.
      var typeLabel = INCENTIVE_LAW_SHORT_LABEL[p.incentiveLawId];
      if (typeLabel) s.setAttribute("data-type-label", typeLabel);
      // cores do widget alinhadas à campanha (fallback = cores da marca AUC)
      var cc = this.campaignColors;
      s.setAttribute("data-color", cc ? this.rgbToHex(cc.primary) : "#009CA6");
      s.setAttribute(
        "data-color-secondary",
        cc ? this.rgbToHex(cc.secondary) : "#8CC63F"
      );
      document.body.appendChild(s);
    },
    // converte "[r, g, b, a]" (formato do tema da campanha) em [r, g, b]
    themeRgbArray(v) {
      if (!v) return null;
      try {
        const arr = typeof v === "string" ? JSON.parse(v) : v;
        if (Array.isArray(arr) && arr.length >= 3)
          return [Number(arr[0]) || 0, Number(arr[1]) || 0, Number(arr[2]) || 0];
      } catch (e) {
        return null;
      }
      return null;
    },
    rgbStr(arr) {
      return "rgb(" + arr[0] + ", " + arr[1] + ", " + arr[2] + ")";
    },
    // luminância perceptual (0..255) para decidir cor de texto sobre a cor
    luminance(arr) {
      return 0.299 * arr[0] + 0.587 * arr[1] + 0.114 * arr[2];
    },
    // escurece cada canal (amount 0..1) — usado para os tons -700/-900/-ink
    darken(arr, amount) {
      const f = 1 - amount;
      return [
        Math.round(arr[0] * f),
        Math.round(arr[1] * f),
        Math.round(arr[2] * f)
      ];
    },
    // clareia misturando com branco (whiteFrac 0..1) — usado para mist/mist-2/sand
    tint(arr, whiteFrac) {
      const f = 1 - whiteFrac;
      return [
        Math.round(arr[0] * f + 255 * whiteFrac),
        Math.round(arr[1] * f + 255 * whiteFrac),
        Math.round(arr[2] * f + 255 * whiteFrac)
      ];
    },
    rgbToHex(arr) {
      return (
        "#" +
        arr
          .map(function (n) {
            const h = Math.max(0, Math.min(255, Math.round(n))).toString(16);
            return h.length === 1 ? "0" + h : h;
          })
          .join("")
      );
    },
    listFileProjectCallback(data) {
      this.fileProjectList = data || [];
    },
    listAllTargetAudienceCallback(data) {
      this.targetAudienceList = data;
    },
    goToCartWithThisProject() {
      if (this.projectLP.project.donationProductList.length > 0) {
        this.$refs.listProductsDialog.open(this.projectLP.project);
        return;
      }

      const route = getCheckoutRoute(this.campaignLandingPageConfig && this.campaignLandingPageConfig.campaign);
      if (route === Routes.web.CartLogged) {
        this.$router.push({ name: route, query: { projectId: this.projectLP.project.id } });
        return;
      }

      // Checkout novo le o carrinho do store: adiciona o projeto antes de navegar.
      this.addToCart({ project: { ...this.projectLP.project, donationProductList: [] } });
      if (!this.logged) return this.$store.commit("SHOW_LOGIN", route);
      this.$router.push({ name: route });
    },
    getActualYear() {
      return moment().format("YYYY");
    },
    async addCampaignProduct() {
      this.donationProductList = this.projectLP.project.donationProductList;
      this.appreciationList.forEach(x => {
        let counter = Math.abs(x.order - this.appreciationList.length);
        this.campaignAppreciationCampaignProduct
          .getCampaignProductByCampaignAppreciationId(x.id)
          .then(async response => {
            this.donationProductList[counter].campaignProduct =
              response.campaignProduct;
            this.donationProductList[counter].campaignProductId =
              response.campaignProductId;
          });
      });
    },
    async addDonationProduct() {
      const allDonProd = await this.projectService.listAllDonationProductsBySubdomain();
      this.donationProductList.forEach(async d => {
        allDonProd.forEach(x => {
          if (
            x.fileId === d.file.id &&
            x.projectId === d.project.id &&
            x.name === d.name &&
            d.suggestionValue === x.suggestionValue
          ) {
            d.id = x.id;
          }
        });
      });
    }
  }
};
</script>

<style scoped>
/* Container do simulador inline no slot da nova página */
.sim-inline-wrap {
  width: 100%;
  max-width: 940px;
  margin: 0 auto;
}
/* wrapper centralizado do rodapé (substitui .container/.v-layout do Vuetify) */
.pp-footer-termo {
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 24px;
}
</style>
